import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import moment from 'moment';
import { Ionicons } from '@expo/vector-icons';
import DatePickerComponent from '../datepicker/DatePickerComponent.web';

const CalenderTextSlider = (props) => {
  const [monthAndYear, setMonthAndYear] = useState(moment().format('MMM YYYY'));

  const onDateChange = (dateMoment) => {
    const obj = {
      month: dateMoment.month() + 1,
      year: dateMoment.year(),
    };
    if (props?.onDateChange) {
      props.onDateChange(obj.month, obj.year);
    }
    if (props?.setMonthYear) {
      props.setMonthYear(obj);
    }
  };

  const handlePrev = () => {
    const prev = moment(monthAndYear, 'MMM YYYY').subtract(1, 'months');
    setMonthAndYear(prev.format('MMM YYYY'));
    onDateChange(prev);
  };

  const handleNext = () => {
    const next = moment(monthAndYear, 'MMM YYYY').add(1, 'months');
    setMonthAndYear(next.format('MMM YYYY'));
    onDateChange(next);
  };

  const handlePickerUpdate = (date) => {
    if (date) {
      const m = moment(date);
      if (m.isValid()) {
        setMonthAndYear(m.format('MMM YYYY'));
        onDateChange(m);
      }
    }
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.navBtn}
        onPress={handlePrev}
        activeOpacity={0.75}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <Ionicons name="chevron-back" size={14} color="#6C2BD9" />
      </TouchableOpacity>

      <View style={styles.centerContent}>
        <Ionicons name="calendar-outline" size={15} color="#6C2BD9" style={{ marginRight: 6 }} />
        <Text style={styles.dateText}>{monthAndYear}</Text>
        <View style={styles.hiddenPickerWrap}>
          <DatePickerComponent
            showMonths={true}
            onUpdateInput={handlePickerUpdate}
          />
        </View>
      </View>

      <TouchableOpacity
        style={styles.navBtn}
        onPress={handleNext}
        activeOpacity={0.75}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <Ionicons name="chevron-forward" size={14} color="#6C2BD9" />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    paddingHorizontal: 8,
    height: 38,
    gap: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 3,
    elevation: 1,
  },
  navBtn: {
    width: 26,
    height: 26,
    borderRadius: 13,
    backgroundColor: '#F0E8FF',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    position: 'relative',
  },
  dateText: {
    fontSize: 13,
    fontWeight: '700',
    color: '#111827',
  },
  hiddenPickerWrap: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    opacity: 0.01,
  },
});

export default CalenderTextSlider;
